import React, {CSSProperties, PropsWithChildren, ReactNode} from 'react';
import DefaultPage from '../../../../layout/common/DefaultPage';
import AdminNavBar from '../AdminNavBar/AdminNavBar';

type AdminPageProps = PropsWithChildren<{
  style?: CSSProperties;
  header?: ReactNode;
}>;

const AdminPage: React.FC<AdminPageProps> = ({children, header, ...rest}) => {
  return (
    <DefaultPage {...rest}>
      {header}
      <div style={{border: '1px solid #dfe5ea'}}>
        <AdminNavBar />
        {children}
      </div>
    </DefaultPage>
  );
};

export default AdminPage;
